import { Environment } from './environment.interface';

export const environment: Environment = {
  production: true,

  serverUrl: 'https://api-help.stageflux.win',

  helpSiteUrl: 'https://help.stageflux.win',

  logging: {
    enabled: false,
  },

  tracking: {
    enabled: false,
  },
};
